import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import { Link } from "react-router-dom";
import CardContent from "@material-ui/core/CardContent";
import LoaderButton from "./LoaderButton";

const useStyles = makeStyles((theme) => ({
  modalButton: {
    display: "flex",
    textAlign: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    justifyContent: "center",
  },
}));

export default function HelpModal(props) {
  const classes = useStyles();

  return (
    <div style={{ overflow: "visible", textAlign: "center", paddingTop: 25 }}>
      <Card className={classes.root}>
        <CardContent>
          {/* Do we want to include links to the pages inside of this modal directly? */}
          <h2>You're in.</h2>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "start",
              textAlign: "start",
              padding: 18,
            }}
          >
            <h4>
              To generate your personal retirement affordability insights,
              please:
            </h4>
            <ol
              style={{ paddingTop: 18, paddingLeft: 12 }}
              className="list-spacing"
            >
              <li>
                Fill out the requested information on your profile page. (See
                icon in the upper right corner.)
              </li>
              <li>
                Fill out the requested information for the income calculator.
                (See "Income" in menu.)
              </li>
              <li>
                Select properties to compare to your current resident. (See
                "Heat Map" in menu.)
              </li>
              <li>Review and browse insights. (See "Heat Map" in menu.)</li>
            </ol>
          </div>
        </CardContent>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <LoaderButton onClick={props.handleClose}>
            <Link to="/" style={{ textDecoration: "none" }}>
              Go to Profile
            </Link>
          </LoaderButton>
        </div>
      </Card>
    </div>
  );
}
